import React from 'react'

import clsx from 'clsx'

import classes from './DialogActions.module.scss'

/** @type {import("./types").default} */
const DialogActions = ({ children, className }) => {
  return <div className={clsx('DialogActions', classes.root, className)}>{children}</div>
}

export default DialogActions
